import React, { createContext, useContext, useEffect, useState } from 'react';
import apiClient from '../../../../../Config/apiClient';

const AdminProfileContext = createContext();
export const useAdminProfile = () => useContext(AdminProfileContext);

const adminPath = process.env.REACT_APP_CC_ADMIN_BASE_PATH;

export const AdminProfileProvider = ({ children }) => {
    const [profileImageUrl, setProfileImageUrl] = useState('');
    const [loadingImage, setLoadingImage] = useState(true);

    const fetchProfileImage = async () => {
        setLoadingImage(true);
        try {
            const res = await apiClient.get(`${adminPath}/profile-image`);
            if (res.data.status === 'SUCCESS') {
                const url = `${res.data.image_url}?t=${Date.now()}`;
                setProfileImageUrl( url );
            } else {
                setProfileImageUrl('');
            }
        } catch {
            setProfileImageUrl('');
        } finally {
            setLoadingImage(false);
        }
    };

    useEffect(() => {
        fetchProfileImage();
    }, []);

    return (
        <AdminProfileContext.Provider value={{ profileImageUrl, setProfileImageUrl, fetchProfileImage, loadingImage, }} >
            {children}
        </AdminProfileContext.Provider>
    );
};
